import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { useQRCode } from './useQRCode'
import { Loading } from '../loading'
import { LottieAnimationName } from '../lotties'

const defaultImageSize = '180px'

const Image = styled.img<{ $size?: string }>`
    width: ${(p) => p.$size ?? defaultImageSize};
    height: ${(p) => p.$size ?? defaultImageSize};
`

interface Props {
    text: string
    size?: number
}

export const QRCode: FC<Props> = ({ text, size }) => {
    const [url, setUrl] = useState('')
    useQRCode(text, setUrl)

    if (!text) {
        return (
            <Loading
                name={LottieAnimationName.LoadSpinner}
                width={`${size ?? defaultImageSize}`}
            />
        )
    }

    // Convert size to a valid CSS string (e.g., '150px') or use default size
    const sizeWithUnit = size ? `${size}px` : defaultImageSize

    return <Image $size={sizeWithUnit} src={url} />
}
